import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useRef, useState } from "react";

interface Props {
  onScan: (text: string) => void;
  onClose: () => void;
}

const InlineQrScanner: React.FC<Props> = ({ onScan, onClose }) => {
  const scannerRef = useRef<Html5QrcodeScanner | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(true);
  }, []);

  useEffect(() => {
    if (!isReady) return;

    // Ensure element exists before trying to initialize
    const checkAndInitialize = () => {
      const element = document.getElementById("qr-reader-inline");
      if (!element) {
        console.warn("QR reader element not found, retrying...");
        setTimeout(checkAndInitialize, 100);
        return;
      }

      try {
        const scanner = new Html5QrcodeScanner(
          "qr-reader-inline",
          { fps: 10, qrbox: 200 },
          false
        );

        scanner.render(
          (decodedText) => {
            onScan(decodedText);
            if (scannerRef.current) {
              scannerRef.current.clear().then(onClose).catch(() => {});
            }
          },
          (errorMessage) => {
            // Silently handle decode errors
            console.debug("QR decode error:", errorMessage);
          }
        );

        scannerRef.current = scanner;
      } catch (error) {
        console.error("Failed to initialize QR scanner:", error);
      }
    };

    checkAndInitialize();

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear().catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [isReady, onScan, onClose]);

  return (
    <div>
      <div id="qr-reader-inline" style={{ width: "100%", minHeight: "300px" }} />
      <p style={{ marginTop: "1rem", fontSize: "0.875rem", color: "#666" }}>
        Position QR code in front of camera
      </p>
    </div>
  );
};

export default InlineQrScanner;
